/* ========================================
   Bundle Builder - カスタムセットビルダー
   ======================================== */

(function () {
  'use strict';

  const MAX_SELECT = 2;

  const grid = document.getElementById('bundle-grid');
  const boxOptions = document.getElementById('bundle-box-options');
  const stepBox = document.getElementById('bundle-step-box');
  const summary = document.getElementById('bundle-summary');
  const summaryItems = document.getElementById('bundle-summary-items');
  const summaryPrice = document.getElementById('bundle-summary-price');
  const addToCartBtn = document.getElementById('bundle-add-to-cart');
  const toast = document.getElementById('bundle-toast');

  if (!grid) return;

  // ペアセット商品をグリッドから除外
  grid.querySelectorAll('.bundle-card').forEach((card) => {
    if (card.dataset.productTitle && card.dataset.productTitle.includes('\u30DA\u30A2\u30BB\u30C3\u30C8')) {
      card.remove();
    }
  });

  /** 選択中のお猪口 Map<variantId, {title, price, image, count}> */
  const selected = new Map();

  /** 選択中の箱 { variantId, title, price, image } | null */
  let selectedBox = null;

  /** 価格フォーマット（Shopify price は cents 単位） */
  function formatMoney(cents) {
    return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
  }

  /** 選択中のお猪口の合計個数（同一商品の複数選択を含む） */
  function totalCupCount() {
    let total = 0;
    selected.forEach((item) => { total += item.count; });
    return total;
  }

  /** サマリーバーを更新 */
  function updateSummary() {
    const cupCount = totalCupCount();
    const isReady = cupCount >= MAX_SELECT && selectedBox !== null;

    // カードの disabled 状態を更新
    const allCards = grid.querySelectorAll('.bundle-card:not(.bundle-card--sold-out)');
    allCards.forEach((card) => {
      const vid = card.dataset.variantId;
      if (cupCount >= MAX_SELECT && !selected.has(vid)) {
        card.classList.add('bundle-card--disabled');
        card.removeAttribute('tabindex');
      } else {
        card.classList.remove('bundle-card--disabled');
        card.setAttribute('tabindex', '0');
      }
      // 同一商品2個選択時はチェックマークを個数に切替
      const checkEl = card.querySelector('.bundle-card__check');
      if (checkEl) {
        const item = selected.get(vid);
        checkEl.textContent = (item && item.count > 1) ? String(item.count) : '✓';
      }
    });

    // STEP2 を強調 & 2個選択完了時に自動スクロール
    if (stepBox) {
      const wasActive = stepBox.classList.contains('bundle-step--active');
      stepBox.classList.toggle('bundle-step--active', cupCount >= MAX_SELECT);
      if (!wasActive && cupCount >= MAX_SELECT) {
        setTimeout(() => {
          stepBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    }

    if (cupCount === 0 && !selectedBox) {
      summary.classList.remove('bundle-summary--visible');
      return;
    }

    summary.classList.add('bundle-summary--visible');

    // アイテム表示
    summaryItems.innerHTML = '';
    let totalCents = 0;
    let first = true;

    const appendItem = ({ title, price, image }) => {
      totalCents += price;
      if (!first) {
        const plus = document.createElement('span');
        plus.className = 'bundle-summary__plus';
        plus.textContent = '+';
        summaryItems.appendChild(plus);
      }
      first = false;

      const item = document.createElement('div');
      item.className = 'bundle-summary__item';
      item.innerHTML = `
        <img class="bundle-summary__item-img" src="${image}" alt="${title}" loading="lazy">
        <span class="bundle-summary__item-name">${title}</span>
      `;
      summaryItems.appendChild(item);
    };

    selected.forEach((item) => {
      for (let i = 0; i < item.count; i++) {
        appendItem(item);
      }
    });

    if (selectedBox) {
      appendItem(selectedBox);
    }

    summaryPrice.textContent = formatMoney(totalCents);
    addToCartBtn.disabled = !isReady;

    // ボタンテキストでガイド
    if (cupCount < MAX_SELECT) {
      addToCartBtn.textContent = `お猪口をあと${MAX_SELECT - cupCount}つ選んでください`;
    } else if (!selectedBox) {
      addToCartBtn.textContent = '箱の色を選んでください';
    } else {
      addToCartBtn.textContent = 'カートに入れる';
    }
  }

  /** お猪口カードのトグル */
  function handleCardToggle(card) {
    if (
      card.classList.contains('bundle-card--sold-out') ||
      card.classList.contains('bundle-card--disabled')
    ) {
      return;
    }

    const vid = card.dataset.variantId;
    const title = card.dataset.productTitle;
    const price = parseInt(card.dataset.productPrice, 10);
    const image = card.dataset.productImage;
    const cupCount = totalCupCount();

    if (cupCount < MAX_SELECT) {
      // 合計が上限未満：同一商品なら個数を増やし、新規なら追加
      if (selected.has(vid)) {
        selected.get(vid).count += 1;
      } else {
        selected.set(vid, { title, price, image, count: 1 });
      }
      card.classList.add('bundle-card--selected');
    } else if (selected.has(vid)) {
      // 上限到達かつ自分が選択中：1個ずつ減らす（2→1→0）
      const item = selected.get(vid);
      if (item.count > 1) {
        item.count -= 1;
      } else {
        selected.delete(vid);
        card.classList.remove('bundle-card--selected');
      }
    } else {
      return;
    }

    updateSummary();
  }

  /** 箱オプションの選択 */
  function handleBoxSelect(option) {
    const vid = option.dataset.variantId;
    const title = option.dataset.productTitle;
    const price = parseInt(option.dataset.productPrice, 10);
    const image = option.dataset.productImage;

    // 同じものを押したら解除
    if (selectedBox && selectedBox.variantId === vid) {
      selectedBox = null;
      option.classList.remove('bundle-box-option--selected');
    } else {
      // 他の選択を解除
      if (boxOptions) {
        boxOptions.querySelectorAll('.bundle-box-option--selected').forEach((el) => {
          el.classList.remove('bundle-box-option--selected');
        });
      }
      selectedBox = { variantId: vid, title, price, image };
      option.classList.add('bundle-box-option--selected');
    }

    updateSummary();
  }

  // お猪口グリッドのイベント
  grid.addEventListener('click', (e) => {
    const card = e.target.closest('.bundle-card');
    if (card) handleCardToggle(card);
  });

  grid.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const card = e.target.closest('.bundle-card');
      if (card) {
        e.preventDefault();
        handleCardToggle(card);
      }
    }
  });

  // 箱オプションのイベント
  if (boxOptions) {
    boxOptions.addEventListener('click', (e) => {
      const option = e.target.closest('.bundle-box-option');
      if (option) handleBoxSelect(option);
    });

    boxOptions.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const option = e.target.closest('.bundle-box-option');
        if (option) {
          e.preventDefault();
          handleBoxSelect(option);
        }
      }
    });
  }

  /** カートに追加 */
  addToCartBtn.addEventListener('click', async () => {
    if (totalCupCount() < MAX_SELECT || !selectedBox) return;

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = '追加中…';

    const items = [];
    selected.forEach((item, vid) => {
      items.push({ id: parseInt(vid, 10), quantity: item.count });
    });
    items.push({ id: parseInt(selectedBox.variantId, 10), quantity: 1 });

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.description || errData.message || 'Cart add failed');
      }

      // 選択リセット
      selected.clear();
      selectedBox = null;
      grid.querySelectorAll('.bundle-card--selected').forEach((c) => {
        c.classList.remove('bundle-card--selected');
        const checkEl = c.querySelector('.bundle-card__check');
        if (checkEl) checkEl.textContent = '✓';
      });
      if (boxOptions) {
        boxOptions.querySelectorAll('.bundle-box-option--selected').forEach((el) => {
          el.classList.remove('bundle-box-option--selected');
        });
      }
      if (stepBox) stepBox.classList.remove('bundle-step--active');
      updateSummary();

      // トースト表示
      toast.classList.add('bundle-toast--visible');
      setTimeout(() => {
        toast.classList.remove('bundle-toast--visible');
      }, 3000);

      // ミニカートを更新
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        });
    } catch (err) {
      console.error('[BundleBuilder] カート追加エラー:', err);
      alert(err.message || 'カートへの追加に失敗しました。もう一度お試しください。');
    } finally {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'カートに入れる';
    }
  });
})();
